import { createAction, createSlice } from "@reduxjs/toolkit";

const registerSlice = createSlice({
  name: "register",
  initialState: { data: null, processing: false, error: null },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      /* TODO: reducer for success*/
      state.data = action.payload;
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
      const { error } = action.payload;
      state.error = error;
    },
    reset(state) {
      state.data = null;
    },
  },
});

const { name, actions, reducer } = registerSlice;
const registerAction = createAction(name);
const resetRegisterAction = actions.reset;

export {
  registerAction,
  resetRegisterAction,
  actions as registerActions,
  reducer as registerReducer,
};
